import { render, staticRenderFns } from "./AddClipMenu.vue?vue&type=template&id=015d882f&scoped=true&"
import script from "./AddClipMenu.vue?vue&type=script&lang=js&"
export * from "./AddClipMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d882f",
  null
  
)

export default component.exports